import axios from 'axios'
import store from '@/store'
import router from '@/router'

/**
 * Axios 实例封装
 * baseURL: 从环境变量读取（开发环境 /prod-api，生产环境 /prod-api）
 * 开发环境通过 devServer 代理到 http://wuliu.gusher.tech
 * 统一处理 token 注入、错误提示、401 跳转登录
 */
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/prod-api',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
    'Authorization': ''
  }
})

// 是否正在刷新 token / 是否已弹过 401 提示（避免重复弹窗）
let isRedirecting = false

// ============ 请求拦截器 ============
service.interceptors.request.use(
  config => {
    // 注入 token
    const token = store.getters['auth/token']
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// ============ 响应拦截器 ============
service.interceptors.response.use(
  response => {
    const res = response.data

    if (response.config.responseType === 'blob') {
      return { data: res }
    }

    // 若依风格：code 200 为成功
    if (res.code !== undefined && res.code !== 200) {
      // 401: token 过期 / 未登录
      if (res.code === 401) {
        handleUnauthorized()
        return Promise.reject(new Error(res.msg || '登录已过期'))
      }
      // 其他业务错误，直接返回让调用方处理
      return Promise.reject(res)
    }

    return res
  },
  error => {
    // HTTP 层面错误
    if (error.response) {
      const status = error.response.status
      if (status === 401) {
        handleUnauthorized()
      }
    }
    return Promise.reject(error)
  }
)

/**
 * 处理 401 未授权：清理登录状态，跳转���录页
 */
function handleUnauthorized() {
  if (isRedirecting) return
  isRedirecting = true

  store.dispatch('auth/logout').finally(() => {
    router.push('/login')
    setTimeout(() => { isRedirecting = false }, 1000)
  })
}

export default service
